import { Component, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { IInputList, IInputCheckedModel } from '../../models';

@Component({
  selector: 'lib-checkbox-list',
  styleUrls: ['./checkbox-list.component.scss'],
  templateUrl: './checkbox-list.component.html',
})
export class CheckboxListComponent {
  @Input() list: IInputList[] = [];
  @Input() labelRightTemplate!: TemplateRef<any>;
  @Input() direction: 'vertical' | 'horizontal' = 'vertical';
  @Input() size: 'small' | 'normal' = 'normal';
  @Input() model: { [key: number]: boolean } = {};
  @Output() valueChange = new EventEmitter();

  get getDirectionClass(): string {
    return this.direction === 'horizontal' ? 'custom-control-inline' : '';
  }

  get getSizeCss(): string {
    return this.size === 'small' ? 'small' : '';
  }

  trackByFn(index: any) {
    return index;
  }

  onChange(key: any, event: { target: { checked: any; }; }) {
    this.valueChange.next({ key, checked: event.target.checked } as IInputCheckedModel);
  }
}
